import React from 'react'
import {removeZeros} from '../../../utils/misc'


export default class CessPercentage extends React.Component {


  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSpecificCessChange = this.handleSpecificCessChange.bind(this)
  }

  handleChange(e) {
    let item = this.props.item, value=e.target.value
    item[e.target.name] = value
    this.props.onChangeCallback(item)
  }

  handleSpecificCessChange(e) {
    let item = this.props.item
    item['specific_cess_amount_edited'] = e.target.value
    this.props.onChangeCallback(item)
  }

  render() {
    let item = this.props.item
    let cessPctInputValue
    if(typeof item['cess_percentage'] !== "undefined") {
      if (isNaN(item['cess_percentage'])) {
        cessPctInputValue = Number(0)
      }
      else {
          cessPctInputValue = removeZeros(item['cess_percentage'])
      }
    }
    else {
      cessPctInputValue = Number(0)
    }
    let cessAmountInputValue
    if(typeof item['specific_cess_amount_edited'] !== "undefined") {
      if (isNaN(item['specific_cess_amount_edited'])) {
        cessAmountInputValue = Number(0)
      }
      else {
          cessAmountInputValue = removeZeros(item['specific_cess_amount_edited'])
      }
    }
    else {
      cessAmountInputValue = Number(item['specific_cess_amount'])
    }
    return <div>
        <input type="number" name="cess_percentage" className="form-control input-sm" value={cessPctInputValue} onChange={this.handleChange} />
        <input type="number" name="specific_cess_amount" className="form-control input-sm" value={cessAmountInputValue} onChange={this.handleChange} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/cess.js